import React from "react";
import { Paths } from "../constants/UrlConstants";
import { getPhone, getOpeningHours } from "../helpers/ContentStateHelper";
import { InboxPages,ButtonConfig } from "../constants/Constants";
import layoutStyle from "../assets/css/modules/shared/layout.css";
import linkStyles from "../assets/css/modules/shared/link.css";
import { Link } from "react-router-dom";

const HowDoIAddOrRemoveAFamilyMember = {
  Question: "How do I add or remove a family member?",
  Answer: {
    Any: (props, params) => (
      <React.Fragment>
        <p>
          For Individual plans, you can send us a 'General enquiry' from the
          inbox, with the details of the change. Alternatively, you can call our
          team of Personal Advisers on {getPhone(props)}. Lines are open{" "}
          {getOpeningHours(props)}.
        </p>
        <p>
          If your plan is part of a Corporate scheme, you will need to contact
          your Human Resources department.
        </p>
      </React.Fragment>
    ),
    HOL: (props, params) => (
      <React.Fragment>
        <p>
          For Individual plans, simply select the 'General enquiry / Document
          upload' option in the inbox, and include details of the change.
          Alternatively, you can call our team of Personal Advisers on{" "}
          {getPhone(props)}. Lines are open {getOpeningHours(props)}.
        </p>
        <p>
          If your plan is part of a Corporate scheme, you will need to contact
          your Human Resources department.
        </p>
      </React.Fragment>
    ),
    International: (
      <React.Fragment>
        <p>
          For Individual plans, you can send us a 'General enquiry' from the
          inbox, with the details of the change. Alternatively, you can call our
          team of Personal Advisers on +44 (0) 1892 503 856. Lines are open day
          and night, 365 days a year.
        </p>
        <p>
          If your plan is part of a Corporate scheme, you will need to contact
          your Human Resources department.
        </p>
      </React.Fragment>
    ),
    SMEModular: (
      <React.Fragment>
        <p>
          As you are part of a Corporate scheme, you will need to contact your
          Human Resources department.
        </p>
      </React.Fragment>
    )
  }
};

const HowDoIChangeMyName = {
  Question: "How do I change my name?",
  Answer: {
    Any: (props, params) => (
      <React.Fragment>
        <p>
          You can change your name by sending us a 'General enquiry' from the
          inbox, with the details of the change. Alternatively, you can call our
          team of Personal Advisers on {getPhone(props)}. Lines are open{" "}
          {getOpeningHours(props)}.
        </p>
        <p>
          Please note: If your name has changed due to marriage, divorce or deed
          poll, please send us a copy of your marriage certificate or the legal
          documents showing your name change.
        </p>
      </React.Fragment>
    ),
    HOL: (props, params) => (
      <React.Fragment>
        <p>
          You can change your name by selecting the 'General enquiry / Document
          upload' option in the inbox, and including details of the change.
          Alternatively, you can call our team of Personal Advisers on{" "}
          {getPhone(props)}. Lines are open {getOpeningHours(props)}.
        </p>
        <p>
          Please note: If your name has changed due to marriage, divorce or deed
          poll, please send us a copy of your marriage certificate or the legal
          documents showing your name change.
        </p>
      </React.Fragment>
    ),
    International: (
      <React.Fragment>
        <p>
          You can change your name by sending us a 'General enquiry' from the
          inbox, with the details of the change. Alternatively, you can call our
          team of Personal Advisers on +44 (0) 1892 503 856. Lines are open day
          and night, 365 days a year.
        </p>
        <p>
          Please note: If your name has changed due to marriage, divorce or deed
          poll, please send us a copy of your marriage certificate or the legal
          documents showing your name change.
        </p>
      </React.Fragment>
    ),
    SMEModular: (
      <React.Fragment>
        <p>
          As you are part of a Corporate scheme, you will need to contact your
          Human Resources department.
        </p>
      </React.Fragment>
    )
  }
};

const HowDoIAddOtherOptionsToMyCover = {
  Question: "How do I add other options to my cover?",
  Answer: {
    Any: (props, params) => (
      <React.Fragment>
        <p>
          To amend the options on your plan, we'll need to speak to you. Please
          call our team of Personal Advisers on {getPhone(props)}. Lines are{" "}
          {getOpeningHours(props)}.
        </p>
      </React.Fragment>
    ),
    HOL: (props, params) => (
      <React.Fragment>
        <p>
          To amend the options on your policy, we'll need to speak to you.
          Please call our team of Personal Advisers on {getPhone(props)}. Lines
          are {getOpeningHours(props)}.
        </p>
      </React.Fragment>
    ),
    International: (
      <React.Fragment>
        <p>
          To amend the options on your plan, we'll need to speak to you. Please
          call our team of Personal Advisers on +44 (0) 1892 503 856. Lines are
          open day and night, 365 days a year.
        </p>
      </React.Fragment>
    )
  }
};

export default {
  ProfileDetailsHeader: { Any: "Profile details", HOL: "Account details" },
  ProfileDetailsDesc:
    "Your contact and login details can be viewed and updated here. To make changes, please follow the links below.",
  CurrentPolicy: {
    Any: "Current plan",
    HOL: "Current policy"
  },
  NumberOfPlans: {
    Any: "Number of plans",
    HOL: "Number of policies"
  },
  MemberName: "Name",
  MemberDateOfBirth: "Date of birth",
  ButtonAddAPlan: {
    Any: "Link another plan",
    HOL: "Link a policy"
  },
  ButtonViewOtherPlans: {
    Any: "View my other plans",
    HOL: "View my other policies"
  },
  MemberAddress: {
    Title: <h2>Address</h2>,
    LinkToFormat1: `${Paths.Inbox}?page=${InboxPages.PlanChanges}`,
    LinkText: "Change address"
  },
  MemberPhone: {
    Title: <h2>Phone number</h2>,
    LinkTo: Paths.ChangePhoneNumber,
    LinkToFormat1: `${Paths.Inbox}?page=${InboxPages.PlanChanges}`,
    LinkText: "Change phone number",
    NoNumberHeld: "No number held",
    MFATitle : <strong>Two-step verification</strong>,
    MFAText:<React.Fragment> If you would like to update the verification phone number used to log in online, call us on <b>0800 302 9133.</b></React.Fragment>
  },
  MemberBank: {
    Title: <h2>Payments to you</h2>,
    LinkToFormat1: `${Paths.Inbox}?page=${InboxPages.PlanChanges}`,
    SubTitleNA: "We can pay any money you're due straight into your bank account just let us know which account.",
    SubTitleWithData:"These are the bank details we'll use when we need to pay you money.",
    SubTitleOA:"When you claim money back, these are the bank details we'll use to pay you.",
    LinkTextUpdate: "Change Bank Details",
    LinkTextAdd:"Add Bank Details",
    InfoText:"If you need to update the bank details we use to take payment for your cover, get tin touch. ",
    contactTitle:"ContactUs",
    NoAccountLinked: "We don't have bank details for paying money to you.",
    NoAccountLinkedOA:"There are no details saved on your account",
    idAdd:ButtonConfig.AddBankDetails,
    idChange:ButtonConfig.ChangeBankDetails,
  },
  MemberEmail: {
    Title: <h2>Email address</h2>,
    LinkText: "Change email address"
  },
  MemberPassword: {
    Title: <h2>Password</h2>,
    LinkText: "Change password",
    DefaultPasswordText: "********"
  },
  ContactDetailsHeading: "My contact details",
  HelpSection: {
    HeadingLinkTo: Paths.Help,
    HeadingLinkText: "Help",
    MoreHelpLinkTo: Paths.Help,
    MoreHelpLinkText: "View more help",
    HelpSetForInternational: [
      HowDoIAddOrRemoveAFamilyMember,
      HowDoIChangeMyName,
      HowDoIAddOtherOptionsToMyCover
    ],
    HelpSetForSMEModular: [HowDoIAddOrRemoveAFamilyMember, HowDoIChangeMyName],
    HelpSetForHarpa: [
      HowDoIAddOrRemoveAFamilyMember,
      HowDoIChangeMyName,
      HowDoIAddOtherOptionsToMyCover
    ],
    HelpSetEP:(Url,IsInternalView)=>[
      {
          Question: "How do I add or remove a family member?",
          Answer: {
            Any:(props, params) => IsInternalView?(
              <>
              <p>
                 For Individual plans, you can {"  "}
                <Link to="/" 
                className={linkStyles.disabled} 
                onClick={ (event) => event.preventDefault() }>
                send us a message{" "}
                </Link>
                with the details of the change. Alternatively, you can call our team of Personal 
                    Advisers on {getPhone(props)}. Lines are open{" "}
                    {getOpeningHours(props)}.
              </p>
              <p>
                  If your plan is part of a Corporate scheme, you will need to contact
                  your Human Resources department.
                </p>
              </>
            ):(
              <React.Fragment>
                <p>
                  For Individual plans, you can {"  "}
                    <a
                      className={"hol-link " + layoutStyle.anchorDecorationUnderline}
                      href={Url}
                      target="_blank"
                      rel="noopener"
                    >
                      send us a message{" "}
                    </a>
                    with the details of the change. Alternatively, you can call our team of Personal 
                    Advisers on {getPhone(props)}. Lines are open{" "}
                    {getOpeningHours(props)}.
                </p>
                <p>
                  If your plan is part of a Corporate scheme, you will need to contact
                  your Human Resources department.
                </p>
              </React.Fragment>
            ),
          }
      },
      {
        Question: "How do I change my name?",
        Answer: {
          Any:(props, params)=> IsInternalView?(
            <>
            <p>
              You can change your name by {" "}
              <Link to="/" 
              className={linkStyles.disabled} 
              onClick={ (event) => event.preventDefault() }>
              sending us a message{" "}
              </Link>
              with the details of the change. Alternatively, you can call our
                team of Personal Advisers on {getPhone(props)}. Lines are open{" "}
                {getOpeningHours(props)}.
            </p>
            <p>
            Please note: If your name has changed due to marriage, divorce or deed poll, 
            please send us a copy of your marriage certificate or the legal documents showing 
            your name change.
          </p>
          </>
            ):(
            <React.Fragment>
              <p>
                You can change your name by {" "}
                <a
                      className={"hol-link " + layoutStyle.anchorDecorationUnderline}
                      href={Url}
                      target="_blank"
                      rel="noopener"
                    >
                      sending us a message{" "}
                    </a>
                with the details of the change. Alternatively, you can call our
                team of Personal Advisers on {getPhone(props)}. Lines are open{" "}
                {getOpeningHours(props)}.
              </p>
              <p>
                Please note: If your name has changed due to marriage, divorce or deed poll, 
                please send us a copy of your marriage certificate or the legal documents showing 
                your name change.
              </p>
            </React.Fragment>
          ),
        }
      },
        {
          Question: "How do I add other options to my cover?",
          Answer: {
            Any: (props, params)=> (
              <React.Fragment>
                <p>
                  To amend the options on your plan, we'll need to speak to you. Please
                  call our team of Personal Advisers on {getPhone(props)}. Lines are{" "}
                  {getOpeningHours(props)}.
                </p>
              </React.Fragment>
            ),
            }
          }
      ],
    HelpSetEPIND: (Url, IsInternalView) => [
      {
        Question: "How do I add or remove a family member?",
        Answer: {
          Any: (props, params) => IsInternalView ? (
            <>
              <p>
                For Individual plans, you can {"  "}
                <Link to="/"
                  className={linkStyles.disabled}
                  onClick={(event) => event.preventDefault()}>
                  send us a message{" "}
                </Link>
                with the details of the change. Alternatively, you can call our team of Personal
                Advisers on {getPhone(props)}. Lines are open{" "}
                {getOpeningHours(props)}.
              </p>
              <p>
                If your plan is part of a Corporate scheme, you will need to contact
                your Human Resources department.
              </p>
            </>
          ) : (
            <React.Fragment>
              <p>
                For Individual plans, you can {"  "}
                <a
                  className={"hol-link " + layoutStyle.anchorDecorationUnderline}
                  href={Url}
                  target="_blank"
                  rel="noopener"
                >
                  send us a message{" "}
                </a>
                with the details of the change. Alternatively, you can call our team of Personal
                Advisers on {getPhone(props)}. Lines are open{" "}
                {getOpeningHours(props)}.
              </p>
              <p>
                If your plan is part of a Corporate scheme, you will need to contact
                your Human Resources department.
              </p>
            </React.Fragment>
          ),
        }
      },
      {
        Question: "How do I change my name?",
        Answer: {
          Any: (props, params) => IsInternalView ? (
            <>
              <p>
                You can change your name by {" "}
                <Link to="/"
                  className={linkStyles.disabled}
                  onClick={(event) => event.preventDefault()}>
                  sending us a message{" "}
                </Link>
                with the details of the change. Alternatively, you can call our
                team of Personal Advisers on {getPhone(props)}. Lines are open{" "}
                {getOpeningHours(props)}.
              </p>
              <p>
                Please note: If your name has changed due to marriage, divorce or deed poll,
                please send us a copy of your marriage certificate or the legal documents showing
                your name change.
              </p>
            </>
          ) : (
            <React.Fragment>
              <p>
                You can change your name by {" "}
                <a
                  className={"hol-link " + layoutStyle.anchorDecorationUnderline}
                  href={Url}
                  target="_blank"
                  rel="noopener"
                >
                  sending us a message{" "}
                </a>
                with the details of the change. Alternatively, you can call our
                team of Personal Advisers on {getPhone(props)}. Lines are open{" "}
                {getOpeningHours(props)}.
              </p>
              <p>
                Please note: If your name has changed due to marriage, divorce or deed poll,
                please send us a copy of your marriage certificate or the legal documents showing
                your name change.
              </p>
            </React.Fragment>
          ),
        }
      },
      {
        Question: "When and how can I make changes to my cover?",
        Answer: {
          Any: (props, params) => (
            <React.Fragment>
              <p>
                You can add options to your plan in the 14 days after you join us, or each year at your renewal once you’ve received your renewal documents.<br></br><br></br>
                You can remove or reduce options or cancel your plan at any time during the year.<br></br><br></br>
                To amend the options on your plan, we'll need to speak with you. <br></br><br></br>Please
                call us on {getPhone(props)}. Lines are open{" "}
                {getOpeningHours(props)}.
              </p>
            </React.Fragment>
          ),
        }
      }]
  }
};
